const Slider = ({ ...props }) => {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width={props?.width ? props?.width : '20'}
      height={props?.height ? props?.height : '20'}
      viewBox="0 0 20 20"
      fill="none"
      {...props}
    >
      <path
        d="M9.375 3.125C8.56689 3.125 7.87842 3.65234 7.61719 4.375H2.5V5.625H7.61719C7.87842 6.34766 8.56689 6.875 9.375 6.875C10.1831 6.875 10.8716 6.34766 11.1328 5.625H17.5V4.375H11.1328C10.8716 3.65234 10.1831 3.125 9.375 3.125ZM9.375 4.375C9.72656 4.375 10 4.64844 10 5C10 5.35156 9.72656 5.625 9.375 5.625C9.02344 5.625 8.75 5.35156 8.75 5C8.75 4.64844 9.02344 4.375 9.375 4.375ZM13.75 8.125C12.9419 8.125 12.2534 8.65234 11.9922 9.375H2.5V10.625H11.9922C12.2534 11.3477 12.9419 11.875 13.75 11.875C14.5581 11.875 15.2466 11.3477 15.5078 10.625H17.5V9.375H15.5078C15.2466 8.65234 14.5581 8.125 13.75 8.125ZM13.75 9.375C14.1016 9.375 14.375 9.64844 14.375 10C14.375 10.3516 14.1016 10.625 13.75 10.625C13.3984 10.625 13.125 10.3516 13.125 10C13.125 9.64844 13.3984 9.375 13.75 9.375ZM6.875 13.125C6.06689 13.125 5.37842 13.6523 5.11719 14.375H2.5V15.625H5.11719C5.37842 16.3477 6.06689 16.875 6.875 16.875C7.68311 16.875 8.37158 16.3477 8.63281 15.625H17.5V14.375H8.63281C8.37158 13.6523 7.68311 13.125 6.875 13.125ZM6.875 14.375C7.22656 14.375 7.5 14.6484 7.5 15C7.5 15.3516 7.22656 15.625 6.875 15.625C6.52344 15.625 6.25 15.3516 6.25 15C6.25 14.6484 6.52344 14.375 6.875 14.375Z"
        fill="black"
      />
    </svg>
  )
}

export default Slider
